export default {
  viewBox: "0 0 24 24",
  html: "<path fill-rule=\"evenodd\" d=\"M2 6v14c0 1.1.9 2 2 2h14v-2H4V6zm6-4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm4 3.5 6 4.5-6 4.5z\"/>"
};